import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DialogBox() {
  const [state, setState] = React.useState({
    open: false,
    title: "",
    description: "",
    isConfirmation: false,
    onConfirm: null,
    buttonText: ["Agree", "Disagree"],
  });

  const handleClose = () => {
    setState({
      open: false,
      title: "",
      description: "",
      isConfirmation: false,
      onConfirm: null,
      buttonText: ["Agree", "Disagree"],
    });
  };

  const showDialog = (title, description = "", buttonText = "Ok") => {
    setState({
      open: true,
      title: title,
      description: description,
      isConfirmation: false,
      onConfirm: null,
      buttonText: ["Agree", buttonText],
    });
  };

  const showConfDialog = (
    title,
    description = "",
    onConfirm = null,
    buttonTexts = ["Agree", "Disagree"]
  ) => {
    setState({
      open: true,
      title: title,
      description: description,
      isConfirmation: true,
      onConfirm: onConfirm,
      buttonText: buttonTexts,
    });
  };

  global.showDialog = showDialog;
  global.showConfDialog = showConfDialog;

  return (
    <Dialog
      open={state.open}
      TransitionComponent={Transition}
      keepMounted
      //   onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{state.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {state.description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          style={{
            backgroundColor: state.isConfirmation ? "red" : "#007afb",
            color: "white",
          }}
          variant="contained"
          onClick={handleClose}
        >
          {state.buttonText[1]}
        </Button>
        {state.isConfirmation && (
          <Button
            style={{
              backgroundColor: "green",
              color: "white",
            }}
            variant="contained"
            onClick={() => {
              handleClose();
              if (state.onConfirm) {
                state.onConfirm();
              }
            }}
          >
            {state.buttonText[0]}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
